module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M10.068 15.936l9.248-9.672a2.065 2.065 0 0 0 0-2.836L16.6.584a1.869 1.869 0 0 0-2.716 0L.564 14.516a2.075 2.075 0 0 0 0 2.844l13.444 14.052a1.862 1.862 0 0 0 2.716 0l2.716-2.836a2.07 2.07 0 0 0 0-2.84l-9.372-9.8zm29.368 9.8l-9.368-9.8 9.248-9.672a2.065 2.065 0 0 0 0-2.836L36.6.584a1.869 1.869 0 0 0-2.716 0l-13.32 13.932a2.075 2.075 0 0 0 0 2.844l13.444 14.052a1.862 1.862 0 0 0 2.716 0l2.716-2.836a2.074 2.074 0 0 0-.004-2.84z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-angle-quote-1.js
// module id = 1216
// module chunks = 14